<template>
  <v-app-bar
    dark
    :height="60"
    fixed
    app
    clipped-right
    clipped-left
    style="z-index: 30"
  >
    <img
      src="@/assets/img/logo_white.svg"
      class="v-toolbar__logo clickable mr-5"
      alt="Ultrax"
      @click="navigateToOverview()"
    >

    <v-spacer />

    <v-toolbar-items class="d-inline-flex align-center">
      <div
        style="width: 500px; min-width: 400px"
      >
        <v-autocomplete
          ref="globalSearch"
          v-model="globalSearch.selected"
          :items="globalSearch.items"
          :loading="globalSearch.loading"
          clearable
          dense
          hide-details
          flat
          solo-inverted
          dark
          return-object
          hide-no-data
          no-filter
          :item-text="itemText"
          :item-disabled="isItemDisabled"
          item-value="_key"
          :placeholder="$t('text_input.search_players_coaches.title')"
          :search-input.sync="globalSearch.search"
          @change="onItemSelected"
        >
          <template v-slot:append>
            <v-icon>
              fal fa-search
            </v-icon>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar
              v-if="item.photo_url"
              size="24"
            >
              <v-img :src="item.photo_url" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <span>{{ item.first_name }} {{ item.last_name }}</span>
                <v-spacer />
                <v-chip
                  v-if="item.type === 'player' && item.is_archived"
                  x-small
                  color="red"
                  dark
                >
                  <v-icon
                    x-small
                    left
                  >
                    fal fa-box-archive
                  </v-icon>
                  {{ $t('player.archived') }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.type === 'player' && item.teams && item.teams.length">
                {{ item.teams.map(t => t.name).join(', ') }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else-if="item.type === 'coach' && item.coach_type && item.coach_type.name">
                {{ item.coach_type.name }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </div>
    </v-toolbar-items>

    <v-spacer />

    <v-toolbar-items class="d-inline-flex align-center">
      <!--      <div class="v-toolbar__buttons d-inline-flex align-center mr-4">-->
      <!--        <v-btn-->
      <!--          icon-->
      <!--          :to="{ name: $routeNames.LOGOUT }"-->
      <!--        >-->
      <!--          <v-icon small>-->
      <!--            fa-light fa-magnifying-glass-->
      <!--          </v-icon>-->
      <!--        </v-btn>-->
      <!--        <v-btn-->
      <!--          icon-->
      <!--          :to="{ name: $routeNames.LOGOUT }"-->
      <!--        >-->
      <!--          <v-icon small>-->
      <!--            fa-light fa-bell-->
      <!--          </v-icon>-->
      <!--        </v-btn>-->
      <!--        <v-btn-->
      <!--          icon-->
      <!--          :to="{ name: $routeNames.LOGOUT }"-->
      <!--        >-->
      <!--          <v-icon small>-->
      <!--            fa-light fa-gear-->
      <!--          </v-icon>-->
      <!--        </v-btn>-->
      <!--      </div>-->
      <div class="mr-5">
        <v-btn
          icon
          @click="EventBus.$emit($events.OPEN_DIALOG_CHANGE_LANGUAGE)"
        >
          <country-flag
            class="ma-1"
            :country="flags[selectedLanguage]"
            rounded
          />
        </v-btn>
      </div>
      <div class="mr-5">
        <v-btn
          icon
          @click="EventBus.$emit($events.OPEN_DIALOG_SUPPORT)"
        >
          <v-icon>
            duotone fa-light fa-headset
          </v-icon>
        </v-btn>
      </div>
      <div class="mr-5">
        <v-menu
          v-model="toolbarMenuActive"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div>
              <v-btn icon>
                <v-avatar
                  color="black"
                  size="40"
                  v-on="on"
                >
                  <v-img
                    v-if="user.photo_url"
                    :src="user.photo_url"
                  />
                  <v-icon
                    v-else
                    color="white"
                  >
                    fa-light fa-user
                  </v-icon>
                </v-avatar>
              </v-btn>
            </div>
          </template>

          <v-card
            class="mt-1"
            :min-width="275"
          >
            <v-list>
              <v-list-item style="padding-right: 0.625em">
                <v-list-item-content>
                  <v-list-item-title
                    v-if="user.first_name && user.last_name"
                    class="subtitle-2"
                  >
                    {{ user.first_name }} {{ user.last_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="user.email">
                    {{ user.email }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    icon
                    @click="onEditProfile"
                  >
                    <v-icon style="height: 1.25em; width: 1.25em">
                      fa-light fa-gear
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider />

            <v-list
              v-if="isChrome && user.organisation_settings && user.organisation_settings.integrations && user.organisation_settings.integrations.some(i => i.key === 'fieldwiz')"
              class="py-0"
            >
              <v-list-item :to="{ name: $routeNames.INSIDERS_HUB }">
                <v-list-item-title class="text">
                  {{ $t("home.insiders_hub") }}
                </v-list-item-title>
                <v-list-item-action class="d-inline-flex justify-center align-center">
                  <img
                    src="@/assets/img/insiders/logo-short.png"
                    width="30px"
                    alt="Insiders device"
                  >
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider />

            <v-list class="py-0">
              <v-list-item :to="{ name: $routeNames.LOGOUT }">
                <v-list-item-title class="error--text">
                  {{ $t('button.logout') }}
                </v-list-item-title>
                <v-list-item-action class="d-inline-flex justify-center align-center">
                  <v-icon color="error">
                    fa-light fa-sign-out-alt
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
      <div v-if="hasAddNewButton">
        <v-btn
          color="white grey--text text--darken-4"
          class="v-btn--add-new rounded"
          @click="onAddNewClick"
        >
          <v-icon
            left
            small
          >
            fal fa-plus
          </v-icon>
          <span class="text-none">
            {{ $t("home.add_new") }}
          </span>
        </v-btn>
      </div>
    </v-toolbar-items>
  </v-app-bar>
</template>
<script>
import { EventBus } from '@/plugins/bus'
import { CoachApiService, PlayerApiService } from '@/data/services'
import debounce from 'lodash/debounce'

export default {
  name: 'AppBar',
  data() {
    return {
      toolbarMenuActive: false,
      adminAreaMenuActive: false,
      selectedLanguage: localStorage.getItem('user-locale') || 'en',
      flags: {
        en: 'gb',
        ru: 'ru',
        de: 'de',
        es: 'es',
        tr: 'tr',
        hr: 'hr',
        cs: 'cz'
      },
      isChrome: false,
      globalSearch: {
        items: [],
        selected: undefined,
        loading: false,
        search: ''
      }
    }
  },
  computed: {
    EventBus() {
      return EventBus
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    isAdmin() {
      return this.$can('manage-organisation')
    },
    hasTrainingBuilderModule() {
      return this.user && this.user.organisation_settings && this.user.organisation_settings.has_training_builder_module
    },
    hasMedicalModule() {
      return this.user && this.user.organisation_settings && this.user.organisation_settings.has_medical_module
    },
    hasMembershipModule() {
      return this.user.organisation_settings && this.user.organisation_settings.has_membership_module
    },
    hasTrainingProgramsModule() {
      return this.user && this.user.organisation_settings && this.user.organisation_settings.has_training_programs_module
    },
    hasDiagnosticsModule() {
      return this.user.organisation_settings?.has_diagnostics_module || false
    },
    hasNoPlayers() {
      return this.user.organisation_settings?.has_no_players || false
    },
    hasNoStaff() {
      return this.user.organisation_settings?.has_no_staff || false
    },
    hasNoEvents() {
      return this.user.organisation_settings?.has_no_events || false
    },
    hasAddNewButton() {
      if ((!this.hasNoEvents && this.$can('create-event')) ||
        (this.hasMedicalModule && !this.hasNoPlayers && this.$can('create-medical')) ||
        (this.$can('create-diagnostics') && this.hasDiagnosticsModule && !this.hasNoPlayers) ||
        (this.hasDiagnosticsModule && !this.hasNoPlayers) ||
        (this.hasTrainingBuilderModule && !this.hasNoPlayers) ||
        (this.hasTrainingProgramsModule && !this.hasNoPlayers) ||
        (this.isAdmin && !this.hasNoPlayers) ||
        (this.isAdmin && !this.hasNoStaff) ||
        (this.isAdmin && !this.hasNoEvents) ||
        (this.isAdmin && this.hasMembershipModule && !this.hasNoPlayers && this.$can('create-membership'))
      ) return true

      return false
    }
  },
  watch: {
    'globalSearch.search': function (val, oldVal) {
      if (!val) return

      this.fetchBySearch(val)
    }
  },
  created() {
    this.detectBrowser()
  },
  methods: {
    onAddNewClick() {
      EventBus.$emit(this.$events.OPEN_DIALOG_SELECT_FORM)
    },
    navigateToOverview() {
      if (this.$route.name !== this.$routeNames.OVERVIEW) {
        this.$router.push({ name: this.$routeNames.OVERVIEW })
      }
    },
    fetchBySearch: debounce(async function (query) {
      if (this.globalSearch.loading) return

      this.globalSearch.loading = true

      try {
        const teamIds = this.user?.coach?.teams?.map(t => t.id) || undefined

        const [playerResult, coachResult] = await Promise.allSettled([
          PlayerApiService.getSimpleList({ order_by: 'last_name', order: 'ASC', no_event_stats: true, team_ids: teamIds, search: query, archived_status: this.$can('view-archived-players') ? 'all' : 'active', per_page: 10 }),
          CoachApiService.getPaginated({ order_by: 'last_name', order: 'ASC', search: query, per_page: 10 })
        ])

        const players = playerResult.status === 'fulfilled'
          ? playerResult.value.data.map(p => ({ ...p, type: 'player', _key: `player-${p.id}` }))
          : []
        const coaches = coachResult.status === 'fulfilled'
          ? coachResult.value.data.map(c => ({ ...c, type: 'coach', _key: `coach-${c.id}` }))
          : []

        const items = []
        if (players.length) {
          items.push({ header: this.$t('dropdown.players.title') })
          items.push(...players)
        }
        if (coaches.length) {
          if (items.length) items.push({ divider: true })
          items.push({ header: this.$t('dropdown.coaches.title') })
          items.push(...coaches)
        }

        this.globalSearch.items = items
      } catch (e) {
        this.globalSearch.items = []
      } finally {
        this.globalSearch.loading = false
      }
    }, 100),
    onItemSelected(item) {
      if (!item || !item.id || !item.type) return

      if (item.type === 'player') {
        if (this.$route.name === this.$routeNames.PLAYER_DETAILS && this.$route.params.id === String(item.id)) return
        this.$router.push({ name: this.$routeNames.PLAYER_DETAILS, params: { id: item.id } })
      } else if (item.type === 'coach') {
        if (this.$route.name === this.$routeNames.COACH_DETAILS && this.$route.params.id === String(item.id)) return
        this.$router.push({ name: this.$routeNames.COACH_DETAILS, params: { id: item.id } })
      }

      this.$nextTick(() => {
        this.globalSearch.selected = undefined
        this.globalSearch.search = ''
      })
    },
    isItemDisabled(item) {
      return !!item.header || !!item.divider
    },
    detectBrowser() {
      const userAgent = window.navigator.userAgent
      this.isChrome = /Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)
    },
    itemText(item) {
      if (item.header || item.divider) return ''
      return item.first_name + ' ' + item.last_name
    },
    onEditProfile() {
      EventBus.$emit(this.$events.EDIT_PROFILE, this.user.coach.id)
    }
  }
}
</script>
